import React from 'react';
import Splash_Signin from '../commons/splash_signin';
import {IndexLink, Link} from 'react-router';
var querystring = require('querystring');
import axios from 'axios';

import ReactGA from 'react-ga';
import {isMobile} from 'react-device-detect';
import Footer2Component from "../commons/footer2";

export default class EnterpriseBrowsePage extends React.Component {
    constructor(props) {
        super(props);

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);

        this.state = {
            first_name_lead: '',
            last_name_lead: '',
            email_name_lead: '',
            title_name_lead: '',
            part_name_lead: '',
            subscrible_name_lead: 0,
            errors: {},
            menuShow: false,
        }
    }

    mouseClick = (evt) => {
        this.setState({menuShow: !this.state.menuShow})
    }

    mouseOut = (evt) => {
        this.setState({menuShow: false})
    }

    mouseLinkClick = (link, evt) => {
        window.location = link;
    }

    render() {

		if (isMobile) {
            return (
                <div className="companies_boxx" id="v-enterprise-browse_mobile">
                    <div className={"block-001 row mr0"}>
                        <Link to="/"><img className={"img_logo"} alt="mini-internships" src="/static/img/homeimg/home2/m-logo.png"/></Link>
                        <div className={"mobile-dropdown"}>
                            <svg onClick={() => this.mouseClick()} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="30" height="30" focusable="false">
                                <title>Menu</title>
                                <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeMiterlimit="10" d="M4 7h22M4 15h22M4 23h22"></path>
                            </svg>
                            <ul onMouseOut={() => this.mouseOut()} onMouseLeave={() => this.mouseOut()}  className={this.state.menuShow?"mobile-menu":"hide-el mobile-menu"}>
                                <li onClick={() => this.mouseLinkClick("/signup")}><span>Join</span></li>
                                <li onClick={() => this.mouseLinkClick("/signin")}><span>Sign in</span></li>
                            </ul>
                        </div>
                        <div className="col-xs-12 text-center t-content">
                            <h2>Browse all Versity Projects</h2>
                            <p>Find the right students and recent grads for your business</p>
                            <a className="btn" href="/signup">Get Started</a>
                        </div>
                        <img className="img_logo_bg cls-image-line" src={"/static/img/homeimg/home2/img-01-line.png"}/>
                    </div>
                    <div className="s-100 s-40">&nbsp;</div>
                    <div className="row main-content popular-services">
                        <div className="div-block-10">
							<div className="link-table">
								<div className="link-table__header-section">
									<h2 className="link-table__top-section-header scroll-anchor" id="71" tabIndex="-1">
										Research & Strategy
									</h2>
								</div>
								<section className="linkster link-table__linkster">
									<div className="linkster__container">
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Regulatory Research
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Public Document Review
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														SWOT Analysis
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Market Research
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Competitive Analysis
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Social Media Competitive Review
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Competitor Prospecting
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Extracting Insights from Data
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Prospect Research
													</a>
												</li>
											</ul>
										</div>
									</div>
								</section>
							</div>
							<div className="link-table">
								<div className="link-table__header-section">
									<h2 className="link-table__top-section-header scroll-anchor" id="71" tabIndex="-1">
										Sales & Business Development
									</h2>
								</div>
								<section className="linkster link-table__linkster">
									<div className="linkster__container">
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Sales Development Rep Assessment
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														List Crunching
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Strategic Partner Identification
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														CRM Lead Cleansing
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Lead Generation
													</a>
												</li>
											</ul>
										</div>
									</div>
								</section>
							</div>
							<div className="link-table">
								<div className="link-table__header-section">
									<h2 className="link-table__top-section-header scroll-anchor" id="71" tabIndex="-1">
										Finance & Accounting
									</h2>
								</div>
								<section className="linkster link-table__linkster">
									<div className="linkster__container">
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Raised Funding Recap
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Corporate Venturing
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Accounts Receivable Aging Report
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Monitoring Payment Trends
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Financial Model Development
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Reconciliation
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Company Summaries
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Debt Covenant Analysis
													</a>
												</li>
											</ul>
										</div>
									</div>
								</section>
							</div>
							<div className="link-table">
								<div className="link-table__header-section">
									<h2 className="link-table__top-section-header scroll-anchor" id="71" tabIndex="-1">
										Design & Creative
									</h2>
								</div>
								<section className="linkster link-table__linkster">
									<div className="linkster__container">
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Branding & styles guides
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Fashion Design
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Illustration
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Interior Design
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														UX Design
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Videography
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Graphic Design
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														UI Design
													</a>
												</li>
											</ul>
										</div>
									</div>
								</section>
							</div>
							<div className="link-table">
								<div className="link-table__header-section">
									<h2 className="link-table__top-section-header scroll-anchor" id="71" tabIndex="-1">
										Operations & Support
									</h2>
								</div>
								<section className="linkster link-table__linkster">
									<div className="linkster__container">
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Community Relations
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Updating User Manual
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														User Experience Testing
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Website Updates
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Data Entry
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Data Reporting
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														File Management
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Online Research
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Strategic Planning
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Transcription
													</a>
												</li>
											</ul>
										</div>
									</div>
								</section>
							</div>
							<div className="link-table">
								<div className="link-table__header-section">
									<h2 className="link-table__top-section-header scroll-anchor" id="71" tabIndex="-1">
										Marketing
									</h2>
								</div>
								<section className="linkster link-table__linkster">
									<div className="linkster__container">
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Content Creation
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Competitive Retargeting
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Case Studies
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Marketing Collateral
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Email Marketing Campaign Development
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Social Media Content Calendar
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Social Media Engagement Feedback
													</a>
												</li>
											</ul>
										</div>
									</div>
								</section>
							</div>
							<div className="link-table">
								<div className="link-table__header-section">
									<h2 className="link-table__top-section-header scroll-anchor" id="71" tabIndex="-1">
										Software Development
									</h2>
								</div>
								<section className="linkster link-table__linkster">
									<div className="linkster__container">
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Website Security Review
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Connecting to an API
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Application Security Review
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Developing Technical Documentation
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Software Testing
													</a>
												</li>
											</ul>
										</div>
									</div>
								</section>
							</div>
							<div className="link-table">
								<div className="link-table__header-section">
									<h2 className="link-table__top-section-header scroll-anchor" id="71" tabIndex="-1">
										Human Resources
									</h2>
								</div>
								<section className="linkster link-table__linkster">
									<div className="linkster__container">
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Job Specifications Review
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Candidate Sourcing
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Job Board Support and Evaluation
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Diversity Best Practices
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Reviewing and Ranking Resumes
													</a>
												</li>
											</ul>
										</div>
									</div>
								</section>
							</div>
							<div className="link-table">
								<div className="link-table__header-section">
									<h2 className="link-table__top-section-header scroll-anchor" id="71" tabIndex="-1">
										Writing
									</h2>
								</div>
								<section className="linkster link-table__linkster">
									<div className="linkster__container">
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Blogging
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Content Strategy
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Copywriting
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Editing
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Ghostwriting
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Grant Writing
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Technical Writing
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Translation
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														User Experience Writing
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Writing
													</a>
												</li>
											</ul>
										</div>
									</div>
								</section>
							</div>
                        </div>
                    </div>
                    <Footer2Component isSlash={true}/>
                </div>
            )
        }

        return (
            <div id="splash" className="v-home">
                <header>
                    <div className="header">
                        <div className="splash_logo"><Link to="/"><img alt="VERSITY" src="/static/img/appimg/top_login_h_logo.png"/></Link></div>
                        <Splash_Signin type="0" openDialog={this.props.openDialog} url="/code/apis.php"/>
                    </div>
                </header>
                <div id="v-enterprise-browse" className="splash_wrapper companies_boxx">
                    <div className="splash-block row pd0">
                        <div className="row tops">
                            <div className="t-header">
                                <div className="content">
                                    <h1 className="title">Browse all Versity Projects</h1>
                                    <span className="sub-title">Find the right students and recent grads for your business</span>
                                </div>
                            </div>
                            <div className="t-footer">
                                <div className="content">
                                    <a className="btn" href="/signup">Get Started</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row main-content popular-services">
						<div className="div-block-10">
							<div className="link-table">
								<div className="link-table__header-section">
									<h2 className="link-table__top-section-header scroll-anchor" id="71" tabIndex="-1">
										Research & Strategy
									</h2>
								</div>
								<section className="linkster link-table__linkster">
									<div className="linkster__container">
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Regulatory Research
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Public Document Review
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														SWOT Analysis
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Market Research
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Competitive Analysis
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Social Media Competitive Review
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Competitor Prospecting
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Extracting Insights from Data
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Prospect Research
													</a>
												</li>
											</ul>
										</div>
									</div>
								</section>
							</div>
							<div className="link-table">
								<div className="link-table__header-section">
									<h2 className="link-table__top-section-header scroll-anchor" id="71" tabIndex="-1">
										Sales & Business Development
									</h2>
								</div>
								<section className="linkster link-table__linkster">
									<div className="linkster__container">
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Sales Development Rep Assessment
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														List Crunching
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Strategic Partner Identification
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														CRM Lead Cleansing
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Lead Generation
													</a>
												</li>
											</ul>
										</div>
									</div>
								</section>
							</div>
							<div className="link-table">
								<div className="link-table__header-section">
									<h2 className="link-table__top-section-header scroll-anchor" id="71" tabIndex="-1">
										Finance & Accounting
									</h2>
								</div>
								<section className="linkster link-table__linkster">
									<div className="linkster__container">
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Raised Funding Recap
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Corporate Venturing
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Accounts Receivable Aging Report
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Monitoring Payment Trends
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Financial Model Development
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Reconciliation
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Company Summaries
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Debt Covenant Analysis
													</a>
												</li>
											</ul>
										</div>
									</div>
								</section>
							</div>
							<div className="link-table">
								<div className="link-table__header-section">
									<h2 className="link-table__top-section-header scroll-anchor" id="71" tabIndex="-1">
										Design & Creative
									</h2>
								</div>
								<section className="linkster link-table__linkster">
									<div className="linkster__container">
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Branding & styles guides
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Fashion Design
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Illustration
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Interior Design
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														UX Design
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Videography
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Graphic Design
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														UI Design
													</a>
												</li>
											</ul>
										</div>
									</div>
								</section>
							</div>
							<div className="link-table">
								<div className="link-table__header-section">
									<h2 className="link-table__top-section-header scroll-anchor" id="71" tabIndex="-1">
										Operations & Support
									</h2>
								</div>
								<section className="linkster link-table__linkster">
									<div className="linkster__container">
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Community Relations
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Updating User Manual
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														User Experience Testing
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Website Updates
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Data Entry
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Data Reporting
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														File Management
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Online Research
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Strategic Planning
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Transcription
													</a>
												</li>
											</ul>
										</div>
									</div>
								</section>
							</div>
							<div className="link-table">
								<div className="link-table__header-section">
									<h2 className="link-table__top-section-header scroll-anchor" id="71" tabIndex="-1">
										Marketing
									</h2>
								</div>
								<section className="linkster link-table__linkster">
									<div className="linkster__container">
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Content Creation
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Competitive Retargeting
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Case Studies
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Marketing Collateral
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Email Marketing Campaign Development
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Social Media Content Calendar
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Social Media Engagement Feedback
													</a>
												</li>
											</ul>
										</div>
									</div>
								</section>
							</div>
							<div className="link-table">
								<div className="link-table__header-section">
									<h2 className="link-table__top-section-header scroll-anchor" id="71" tabIndex="-1">
										Software Development
									</h2>
								</div>
								<section className="linkster link-table__linkster">
									<div className="linkster__container">
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Website Security Review
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Connecting to an API
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Application Security Review
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Developing Technical Documentation
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Software Testing
													</a>
												</li>
											</ul>
										</div>
									</div>
								</section>
							</div>
							<div className="link-table">
								<div className="link-table__header-section">
									<h2 className="link-table__top-section-header scroll-anchor" id="71" tabIndex="-1">
										Human Resources
									</h2>
								</div>
								<section className="linkster link-table__linkster">
									<div className="linkster__container">
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Job Specifications Review
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Candidate Sourcing
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Job Board Support and Evaluation
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Diversity Best Practices
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Reviewing and Ranking Resumes
													</a>
												</li>
											</ul>
										</div>
									</div>
								</section>
							</div>
							<div className="link-table">
								<div className="link-table__header-section">
									<h2 className="link-table__top-section-header scroll-anchor" id="71" tabIndex="-1">
										Writing
									</h2>
								</div>
								<section className="linkster link-table__linkster">
									<div className="linkster__container">
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Blogging
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Content Strategy
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Copywriting
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Editing
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Ghostwriting
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Grant Writing
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Technical Writing
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Translation
													</a>
												</li>
											</ul>
										</div>
										<div className="link-column">
											<ul className="link-column__list">
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														User Experience Writing
													</a>
												</li>
												<li className="link-column__item">
													<a className="link-column__link"
													   data-tracking-will-navigate="">
														Writing
													</a>
												</li>
											</ul>
										</div>
									</div>
								</section>
							</div>
						</div>
                    </div>
                </div>
                <Footer2Component isSlash={true}/>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/pages/enterprise-browse.js
 **/